//
//
//
//
//
//
//
//

import { parseCategory } from '~/utils/api'
import { meta } from '~/utils/meta'

export default {
  props: {
    categoriesStoryPath: {
      type: String,
      required: true,
    },
    metaFallbackDescription: {
      type: String,
      default: undefined,
    },
  },
  data () {
    return {
      category: null
    }
  },
  fetchKey (getCounter) {
    return `_category:${this.$route.params.categoryId}:${getCounter('category-page')}`
  },
  async fetch () {
    try {
      this.category = await this.$api.getCategory(this.$route.params.categoryId).then(r => parseCategory(r.data.data))
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  },
  head () {
    if (!this.category) { return }

    return meta({
      title: this.category.metaTitle || this.category.name + ' - Docue',
      description: this.category.metaDescription || this.metaFallbackDescription
    })
  }
}
